/**
 * i18n configuration.
 *
 * Default language: Japanese (ja).
 * Supported languages: Japanese (ja), English (en).
 * Falls back to 'ja' if a key is missing in the active locale.
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import ja from "./locales/ja.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ja: { translation: ja },
  },
  lng: "ja",          // default language
  fallbackLng: "ja",
  interpolation: {
    escapeValue: false, // React already escapes
  },
});

export default i18n;
